import React from 'react'
import styled from 'styled-components'
import {connect} from 'react-redux'
import {injectIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import MenuItem from '@mui/material/MenuItem'
import Toolbar from '@mui/material/Toolbar'
import Menu from '@mui/material/Menu'
import Avatar from '@mui/material/Avatar'
import AppBar from '@mui/material/AppBar'
import {ExitToApp, KeyboardArrowDown, SettingsApplications, Phone, Person, Language} from '@mui/icons-material'
import {LanguageContext} from 'containers/Intl'
import UserImage from 'components/UserImage'
import Icon from 'components/Icons'
import {fetchLogout} from 'modules/login/actions'
import {fetchCallUsers} from 'modules/applications/actions'
import {getLanguages} from 'utils/utils'

const User = styled.div`
    display: flex;
    align-items: center;
    font-size: 16px;
    cursor: pointer;
`

const Flag = styled(Icon)`
    border-radius: 50%;
	margin-right: 10px;
`

const Container = styled(AppBar)`
    height: ${props => props.size === 'small' ? 60 : 117}px;
    padding-left: ${props => props.padding}px;
    box-shadow: ${props => props.size === 'small' ? 'none' : '0 3px 5px 0 #cadce0'};
    color: #4a4a4a;
    background: #FFF;
`

const Globe = styled(Avatar)`
	margin-left: 20px;
	cursor: pointer;
`

const Call = styled(Globe)`
	background-color: #fdc22d;
	color: #fff;
`

const Top = styled(Toolbar)`
	padding: 0 16px 10px 16px;
	justify-content: flex-end;
    min-height: 50px;
`

const Item = styled(MenuItem)`
	> svg {
		margin-right: 10px;
	}
`

class Header extends React.Component {
	static contextType = LanguageContext

    constructor(props) {
        super(props)
		
		this.languages = getLanguages()
		
        this.state = {
            anchorEl: null,
            name: null
        }
    }

    componentDidMount() {
        this.props.fetchCallUsers()
    }

    handleChangeLanguage = (e) => {
		this.handleClose()
		this.context.setLang(e.currentTarget.id)
    }

    handleClick = (e) => {
        this.setState({
            anchorEl: e.currentTarget,
            name: e.currentTarget.id
        })
    }

    handleClose = () => {
        this.setState({
            anchorEl: null,
            name: null
        })
    }

    render() {
        const {intl, image, username } = this.props
		const lang = this.context.lang

        return (
            <Container position="fixed" padding={this.props.padding} size={this.props.size}
            >
                <Top>
                    {this.props.children && this.props.children.length ? this.props.children[0] : this.props.children}
                    {this.languages.length &&
						<Globe id='lang' onClick={this.handleClick}>
							<Language />
                    	</Globe>
                    }
                    <Call id='users' onClick={this.handleClick}>
                        <Phone />
                    </Call>
                    <UserImage type={image.type}
                        value={image.value}
                        size='small'
                        margin={'0 10px 0 20px'}
                    />
                    <User id='user' onClick={this.handleClick}>
                        {username}
                        <KeyboardArrowDown style={{fontSize: '22px'}}/>
                    </User>
					<Menu
						anchorEl={this.state.anchorEl}
						open={this.state.name === 'users'}
						onClose={this.handleClose}
						PaperProps={{
							style: {
								margin: '10px 0'
							}
						}}
					>
						{this.props.users.map((item, index) =>
							<Item onClick={this.handleClose}
								component='a'
								key={index}
								href={item.callUrl}
								target='_blank'
							>
								<Person />
								{item.name}
							</Item>
						)}
					</Menu>
					<Menu
						anchorEl={this.state.anchorEl}
						open={this.state.name === 'user'}
						onClose={this.handleClose}
						PaperProps={{
							style: {
								margin: '10px 0'
							}
						}}
					>
						<Item component={Link} to={'/profile'}>
							<SettingsApplications />
							{intl.formatMessage({id: "header.profile"})}
						</Item>
						<Item onClick={this.props.fetchLogout} style={{ color: '#d45b4a'}}>
							<ExitToApp />
							{intl.formatMessage({id: "header.logout"})}
						</Item>
					</Menu>
					<Menu
						anchorEl={this.state.anchorEl}
						open={this.state.name === 'lang'}
						onClose={this.handleClose}
						PaperProps={{
							style: {
								margin: '10px 0'
							}
						}}
					>
						{this.languages.map(item =>
							<MenuItem key={item.id} id={item.id} selected={lang === item.id} onClick={this.handleChangeLanguage}>
								<Flag icon={item.id} width={25} height={25} />
								{item.name}
							</MenuItem>
						)}
					</Menu>
                </Top>
                {this.props.children && this.props.children.length ? this.props.children[1] : null}
            </Container>
        )
    }
}

const mapStateToProps = ({login, applications}) => ({
    image: login.logo,
    username: login.username,
    users: applications.contacts
})

export default connect(mapStateToProps, {
    fetchLogout,
    fetchCallUsers
})(injectIntl(Header))
